import React from 'react';

import { CtaButton, SingleLineInput } from '@opendoor/bricks';
import { isNil } from 'lodash';

export interface IAccountPasswordFormProps {
  email: string;
  rememberMe: boolean;
  loading?: boolean;
  loginError?: string | boolean;
  onSubmit: (password: string) => void;
  onChangeRememberMe: (rememberMe: boolean) => void;
}

export interface IAccountPasswordFormState {
  hasError: boolean;
  password: string;
  rememberMe: boolean;
}

const NO_OP = () => undefined;

export default class AccountPasswordForm extends React.Component<
  IAccountPasswordFormProps,
  IAccountPasswordFormState
> {
  public state: IAccountPasswordFormState = {
    hasError: false,
    password: '',
    rememberMe: this.props.rememberMe,
  };

  public validatePasswordLength = (password: string) => {
    return password.length >= 5 && password.length <= 128;
  };

  public onChange = (name: string, password?: string) => {
    this.setState({
      hasError: isNil(password) || !this.validatePasswordLength(password),
      password,
    });
  };

  public handleSubmit = e => {
    e.preventDefault();
    const { onSubmit } = this.props;
    const { password, hasError } = this.state;

    if (!hasError) {
      onSubmit(password);
    }
  };

  public handleChangeRememberMe = () => {
    const { onChangeRememberMe } = this.props;
    const { rememberMe } = this.state;

    this.setState({ rememberMe: !rememberMe });
    onChangeRememberMe(!rememberMe);
  };

  public render() {
    const { loading, loginError, rememberMe } = this.props;
    const { password, hasError } = this.state;

    return (
      <form onSubmit={this.handleSubmit}>
        <div className="input-section text-left">
          <SingleLineInput
            title="Password"
            name="password"
            onChange={this.onChange}
            errorMessage={hasError ? 'Your password must be 5 to 128 characters long.' : undefined}
            hasError={hasError}
            placeholder="Password"
            inputType="password"
            required={true}
            unboundedWidth={true}
            content={password}
            autoFocus={true}
          />
          {loginError && (
            <div>
              <p className="text-red">
                {typeof loginError === 'string' ? loginError : 'Invalid password.'}
              </p>
              <u>
                <a className="text-red" href="/reset-password/new" target="_self">
                  Click here to reset your password.
                </a>
              </u>
            </div>
          )}
          <p className="input-field small-margin-top">
            <input
              checked={rememberMe}
              name="remember-me"
              onChange={this.handleChangeRememberMe}
              type="checkbox"
            />
            <b>Remember Me</b>
          </p>
          <div className="submit-button">
            <CtaButton actionText={'Sign in'} loading={loading} onClick={NO_OP} type="submit" />
          </div>
          <p className="text-small text-center">
            <a href="/reset-password/new" target="_self">
              Forgot password?
            </a>
          </p>
        </div>
      </form>
    );
  }
}
